import { render, staticRenderFns } from "./StripedString.vue?vue&type=template&id=a6863664"
import script from "./StripedString.vue?vue&type=script&lang=ts"
export * from "./StripedString.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports